// eslint-disable-next-line no-restricted-imports
import {debounce, each, get, includes, isEmpty, isUndefined, mixin, set} from 'lodash';

import {getCookie, removeCookie, setCookie} from 'common/util/cookie';
import {parseUri} from 'common/util';
import {incrementUserFlag, setUserFlag} from 'common/report/queries/app-api/user-flags';
import {isStandalone} from 'common/report/util/env';
import {getPageLoadPerfProps, trackReportLoadPerf} from 'common/report/perf-measure';
import {
  registerUnpersisted,
  setReferrerSuperpropsAndBaseTracking,
  setUserBasedTrackingProps,
} from 'common/report/report-tracker';
import {trackVisitedReport} from 'common/util/server-tracking';

_.noConflict(); // don't export lodash as window global

// django templates access mp.cookie, mp.utility and _ as globals
// export them in window only if non-standalone (django mode)
if (!isStandalone()) {
  const utility = (mp.utility = mp.utility || {});
  Object.assign(utility, {
    get_page_load_perf_props: getPageLoadPerfProps,
    increment_flag: incrementUserFlag,
    register_unpersisted: registerUnpersisted,
    set_flag: setUserFlag,
    set_referrer_superprops_and_base_tracking: setReferrerSuperpropsAndBaseTracking,
    set_user_based_tracking_props: setUserBasedTrackingProps,
    track_visited_report: trackVisitedReport,
    track_report_load_perf: trackReportLoadPerf,
    parseUri,
  });

  mp.cookie = {
    set: setCookie,
    get: getCookie,
    remove: removeCookie,
  };

  // django template uses underscore but we export equivalent lodash functions if _ not present
  if (!window[`_`]) {
    const lodash = (window[`_`] = {
      debounce,
      each,
      isUndefined,
      isEmpty,
      includes,
      contains: includes,
    });

    mixin(
      lodash,
      {
        namespace(obj, path) {
          let value: any;
          if (isUndefined(path)) {
            path = obj;
            value = get(this, path, {});
            obj = set(this, path, value);
          } else {
            value = get(obj, path, {});
            obj = set(obj, path, value);
          }
          return value;
        },
      },
      {chain: false},
    );
  }
}
